var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2LaundryRoomBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 22.72V33H54v27H23V33H13V22.72S22.79 20 30.09 18a8 8 0 0015.82 0L64 22.72z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Laundry_room_bis.07eaeec9.svg";
export { SvgE2LaundryRoomBis as ReactComponent };